import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./model_type.js";
//#region src/model_type_helper.ts
var model_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(type) {
	switch (type) {
		case 93: return "affinity generation run";
		case 86: return "affinity rule";
		case 66: return "appearance";
		case 5: return "badge";
		case 17: return "kiosk log";
		case 42: return "build";
		case 73: return "changeset";
		case 82: return "compound mod group";
		case 25: return "counter";
		case 40: return "coupon";
		case 46: return "customer";
		case 60: return "customer delivery address";
		case 49: return "customer favorites";
		case 48: return "customer login attempt";
		case 47: return "customer payment method";
		case 61: return "customer push token";
		case 95: return "db migration";
		case 0: return "db-settings";
		case 53: return "deleted entry";
		case 6: return "glossary term";
		case 91: return "enterprise tag";
		case 50: return "expo printer";
		case 45: return "external-auth-strategy";
		case 19: return "guest";
		case 37: return "integration";
		case 76: return "integration supplementary data";
		case 23: return "kiosk";
		case 18: return "kiosk status";
		case 75: return "kor tick";
		case 14: return "location";
		case 43: return "location group";
		case 51: return "location throttle";
		case 83: return "loyalty signup";
		case 30: return "maitred activity";
		case 1: return "menu";
		case 9: return "menu cover";
		case 71: return "menu cover promo";
		case 2: return "menu item";
		case 65: return "menu item affinities";
		case 90: return "menu item affinity run";
		case 3: return "menu section";
		case 10: return "menu structure";
		case 11: return "day part";
		case 13: return "mod";
		case 4: return "modifier group";
		case 70: return "olo order";
		case 63: return "open hours override";
		case 67: return "open hours";
		case 96: return "opportunity analysis run";
		case 16: return "order";
		case 68: return "order total rollup";
		case 36: return "org";
		case 94: return "org category stats";
		case 89: return "org chunk config";
		case 72: return "queue job metadata";
		case 31: return "quicksand record";
		case 78: return "quiz";
		case 77: return "quiz step";
		case 58: return "recommendation result";
		case 62: return "recommendation rule";
		case 64: return "recommendation variation";
		case 52: return "rejected transaction";
		case 80: return "reporting location";
		case 79: return "reporting order";
		case 24: return "report schedule";
		case 74: return "settings";
		case 57: return "site";
		case 56: return "system health incident";
		case 55: return "system health summary";
		case 22: return "tax profile";
		case 81: return "third party order";
		case 21: return "transaction";
		case 92: return "scoped sequence state";
		case 12: return "user";
		case 44: return "user role";
		case 38: return "vendor";
		case 69: return "webhook";
		case 84: return "kor alert subscription";
		case 85: return "kor alert incident";
	}
}
//#endregion
export { model_type_helper_exports, name };

//# sourceMappingURL=model_type_helper.js.map